<template>
  <div class="index-contact">
    <comTop></comTop>
    <div class="index_contact_box">
      <el-row>
        <el-col :span="6" :offset="4">
          <div class="contact_left_box">
            <h2 style="padding: 15px 0;">
              <span class="contact_left_box_color"></span>客户服务
            </h2>
            <div>
              <div class="contact_left">
                <img src="./../../assets/img/ico-zuobiao.png" />
                <span>公司地址</span>
              </div>
              <p>浙江杭州</p>
            </div>
            <div>
              <div class="contact_left">
                <img src="./../../assets/img/ico-dianhua.png" />
                <span>联系电话</span>
              </div>
              <p>400-800-1271 - 9:00 - 20:00 (7*10小时)</p>
            </div>
          </div>

          <div class="contact_left_box">
            <h2 style="padding: 15px 0;">
              <span class="contact_left_box_color"></span>商务合作
            </h2>
            <div>
              <div class="contact_left">
                <img src="./../../assets/img/ico-youxiang.png" />
                <span>联系电话</span>
              </div>
              <p>hzyhamc@hzyhamc.com</p>
            </div>
          </div>
        </el-col>
        <el-col :span="14">
          <div>
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item>
                <el-row>
                  <el-col><span class="contact_1">联系我们</span></el-col>
                  <el-col><span class="contact_2">Contact Us</span></el-col>
                  <el-col><div class="contact_3"></div></el-col>
                </el-row>
              </el-form-item>
              <el-form-item label=" " prop="enterpriseName">
                <el-input v-model="ruleForm.enterpriseName" placeholder="请输入您的企业全称"></el-input>
              </el-form-item>

              <el-form-item label=" " prop="phone">
                <el-input v-model="ruleForm.phone" placeholder="请输入您的联系方式"></el-input>
              </el-form-item>

              <el-form-item label=" " prop="note">
                <el-input :autosize="{ minRows: 4}" type="textarea" v-model="ruleForm.note" placeholder="备注"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="addContactUs('ruleForm',ruleForm)">立即提交⇀</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </div>
    <comFooter></comFooter>
  </div>
</template>
<script>
import comTop from "@/components/page/comTop.vue"; //头部
import comFooter from "@/components/page/comFooter.vue"; //脚部
export default {
  components: {
    comFooter,
    comTop
  },
  data() {
    return {
      ruleForm: {
        enterpriseName: "",
        phone: "",
        note: ""
      },
      rules: {
        enterpriseName: [
          { required: true, message: "请输入您的企业全称", trigger: "change" }
        ],
        phone: [
          { required: true, message: "请输入您的联系方式", trigger: "change" }
        ],
        note: [{ required: true, message: "备注", trigger: "change" }]
      }
    };
  },
  computed: {},
  watch: {},
  methods: {
    addContactUs(formName,data){
      let that = this;

      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.ajaxJson({
            url: "/website/addContactUs",
            data:{
              enterpriseName: data.enterpriseName,
              phone:data.phone,
              note:data.note,
            },
            success: function(data) {
              if (data.code == "0000") {
                that.$message.success('提交成功，请耐心等待反馈!');
                that.ruleForm = {
                  enterpriseName : "",
                  phone: "",
                  note: ""
                };
              }else{
                that.$message.error(data.message);
              }
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};
</script>
<style>
.index_contact_box {
  background: #ffffff;
}
.contact_left {
  display: flex;
  align-items: center;
}
.contact_left img {
  padding: 15px;
}
.contact_left_box p {
  padding: 0 15px;
  color: rgba(77, 76, 80, 1);
  font-size: 12px;
}
.contact_left_box .contact_left_box_color {
  width: 8px;
  background: rgba(26, 91, 101, 1);
  display: inline-block;
}
.contact_left_box h2 {
  display: flex;
}
.contact_left_box h2 span {
  margin: 0 10px;
}
.demo-ruleForm .el-form-item input{
  background:rgba(26,91,101,1);
  color: #FFF;
}

.demo-ruleForm .el-form-item textarea{
  background:rgba(26,91,101,1);
  color: #FFF;
}
.demo-ruleForm{
  background:rgba(26,91,101,1);
  padding: 50px 220px 50px 0;
}
.demo-ruleForm .contact_1{
  font-size:45px;
  font-family:Helvetica;
  color:rgba(255,255,255,1);
}
.demo-ruleForm .contact_2{
  font-size:20px;
  font-family:Helvetica;
  color:rgba(255,255,255,1);
}
.demo-ruleForm .contact_3{
  height:1px;
background:rgba(255,255,255,1);
margin: 18px 0 0 0;
}
.demo-ruleForm .el-form-item{
  padding: 8px 0;
}
.demo-ruleForm .el-form-item .el-button--primary {
    color: #FFF;
    background-color: rgba(26,91,101,1);
    border-color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/page/contact.vue